<sh-dropdown
    #dropdown
    [label]="label()"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
>
    <!-- Show loading indicator while resolving initial value -->
    @if (isLoadingValue() && !selectedUser && !searchTerm()) {
        <sh-menu-item label="Loading..." [active]="true" disabled="true"></sh-menu-item>
    }

    <!-- Show selected user if exists and no search term -->
    @if (selectedUser && !searchTerm()) {
        <sh-menu-item
            [label]="getUserDisplayName(selectedUser)"
            [value]="selectedUser.gid"
            [active]="true"
            (click)="handleClear()"
        ></sh-menu-item>
    }

    <!-- Show loading state -->
    @if (isLoading()) {
        <sh-menu-item label="Loading..." disabled="true"></sh-menu-item>
    }

    <!-- Show search results -->
    @if (!isLoading() && searchResults().length > 0) {
        @for (user of searchResults(); track user.gid) {
            <sh-menu-item
                [attr.data-testid]="optionTestId() ? optionTestId() + '-' + user.gid : null"
                [label]="getUserDisplayName(user)"
                [value]="user.gid"
                [active]="isUserActive(user.gid)"
                (click)="handleUserSelect(user)"
            ></sh-menu-item>
        }
    }

    <!-- Show no results message -->
    @if (!isLoading() && searchResults().length === 0 && !selectedUser) {
        <sh-menu-item label="No users found" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
